import { render } from "./RecurringExpenses.vue?vue&type=template&id=5de64384&scoped=true"
import script from "./RecurringExpenses.vue?vue&type=script&lang=js"
export * from "./RecurringExpenses.vue?vue&type=script&lang=js"

import "./RecurringExpenses.vue?vue&type=style&index=0&id=5de64384&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de64384"]])

export default __exports__